import { render, staticRenderFns } from "./SolicitudesVehiculosDetalles.vue?vue&type=template&id=5afa6ea2"
import script from "./SolicitudesVehiculosDetalles.vue?vue&type=script&lang=js"
export * from "./SolicitudesVehiculosDetalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports